import router from '@/router/';

// helpers
import { get } from '@/helpers/requests';

// utils
import { haveProperty } from '@/utils/';

/**
 *
 * Criação do objecto de um assoiado.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados.
 *
 * @param {Object}  data
 *
*/
const create = async data => {
    const { isAdd } = router.history.current.meta;
    const clientFees = [];
    const currentYear = new Date().getFullYear();

    if ( !isAdd ) {
        // Obtenção das keys do payload relacionadas com as quotas
        const quotasKeys = Object.keys( data ).filter( key => key.includes( 'payed-' ) || key.includes( 'invoiceNumber-' ) );
        // Obtenção dos ids dessas keys e remoção dos ids duplicados
        const quotaIds = quotasKeys.map( key => key.split( '-' )[1] );
        const singleQuotaIds = [ ...new Set( quotaIds ) ];

        // por quota, envia o seu id, data do pagamento de tiver e número de fatura se tiver.
        singleQuotaIds.forEach( ( id, index ) => {
            clientFees[`clientFees[${index}][id]`] = id;

            // eslint-disable-next-line
            if ( data.hasOwnProperty( `payed-${id}` ) ) {
                clientFees[`clientFees[${index}][payment_date]`] = data[`payed-${id}`]
                    ? new Date().toISOString().split( 'T' )[0]
                    : '';
            }

            // eslint-disable-next-line
            if ( data.hasOwnProperty( `invoiceNumber-${id}` ) )
                clientFees[`clientFees[${index}][invoice_number]`] = data[`invoiceNumber-${id}`];
        });
    } else {
        // Obtém as fees do ano atual.
        // eslint-disable-next-line
        const fees = await get( '/fees' ).then( ({ data }) => data.data );

        // Criação do objeto das quotas
        fees.forEach( ( fee, index ) => {
            if ( fee.type.id === parseInt( data.type, 10 ) && fee.year >= currentYear ) {
                clientFees[`clientFees[${index}][fee_id]`] = fee.id;
                clientFees[`clientFees[${index}][value]`] = fee.subscription;
            }
        });
    }

    const client = {
        ...( data.number && { number: data.number }),
        ...( data.type && { type: data.type }),
        ...( data.prefix && { prefix: data.prefix }),
        ...( data.name && { name: data.name }),
        ...( data.simpleName && { simple_name: data.simpleName }),
        ...( data.address && { address: data.address }),
        ...( data.zipCode && { zip_code: data.zipCode }),
        ...( data.region && { region: data.region }),
        ...( data.country && { country_id: parseInt( data.country, 10 ) }),
        ...( data.nif && { nif: data.nif }),
        ...( data.paymentMethod && { payment_method: data.paymentMethod }),
        ...( data.profession && { profession: data.profession }),
        ...( data.organization && { organization: data.organization }),
        ...( data.role && { role: data.role }),
        ...( data.email && { email: data.email }),
        ...( data.primaryPhone && { primary_phone: data.primaryPhone }),
        ...( data.secondaryPhone && { secondary_phone: data.secondaryPhone }),
        ...( data.fax && { fax: data.fax }),
        ...( data.admissionDate && { admission_date: data.admissionDate }),
        ...( data.readmissionDate && { readmission_date: data.readmissionDate }),
        ...( data.leavingDate && { leaving_date: data.leavingDate }),
        ...( data.leavingReason && { leaving_reason: data.leavingReason }),
        ...( haveProperty( data, 'observations' ) && { observations: data.observations }),
        ...( Object.keys( clientFees ).length && { ...clientFees })
    };

    return client;
};

const requiredFields = [
    { field: 'number', isRequiredOnEdit: false },
    { field: 'type', isRequiredOnEdit: false },
    { field: 'prefix', isRequiredOnEdit: false },
    { field: 'name', isRequiredOnEdit: false },
    { field: 'address', isRequiredOnEdit: false },
    { field: 'region', isRequiredOnEdit: false },
    { field: 'zipCode', isRequiredOnEdit: false },
    { field: 'country', isRequiredOnEdit: false },
    { field: 'nif', isRequiredOnEdit: false },
    { field: 'paymentMethod', isRequiredOnEdit: false },
    { field: 'profession', isRequiredOnEdit: false },
    { field: 'organization', isRequiredOnEdit: false },
    { field: 'role', isRequiredOnEdit: false },
    { field: 'email', isRequiredOnEdit: false },
    { field: 'admissionDate', isRequiredOnEdit: false }
];

export {
    create,
    requiredFields
};